"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.formatTimestamp = exports.redirectToAgent = exports.getDefaultPrompt = exports.validateOnSave = exports.saveEnvVariablesForActions = exports.isNotAValidUrl = void 0;
var History_1 = __importDefault(require("@src/History"));
var api_1 = require("../CodeNode/store/api");
exports.isNotAValidUrl = function (url) {
    var pattern = new RegExp('^https?:\\/\\/');
    return !pattern.test(url);
};
function saveEnvVariablesForActions(domainId, envVariables, cb) {
    var _this = this;
    if (cb === void 0) { cb = function (msg) { }; }
    var data = {
        env_variables: envVariables,
    };
    return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
        var envResponse, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, api_1.saveEnvVariables(domainId, data)];
                case 1:
                    envResponse = _a.sent();
                    resolve(envResponse);
                    cb();
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _a.sent();
                    cb('Error! There was a problem in completing your request');
                    reject(e_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); });
}
exports.saveEnvVariablesForActions = saveEnvVariablesForActions;
exports.validateOnSave = function (actionData, errors) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41, _42, _43, _44, _45, _46, _47, _48;
    var actionName = actionData.name;
    var actionType = actionData.action_type;
    var actionDescription = (_b = (_a = actionData.function_details) === null || _a === void 0 ? void 0 : _a.function_description) !== null && _b !== void 0 ? _b : '';
    var functionName = (_c = actionData.function_name) !== null && _c !== void 0 ? _c : '';
    var functionParameterList = (_e = (_d = actionData.function_details) === null || _d === void 0 ? void 0 : _d.function_params) !== null && _e !== void 0 ? _e : [];
    var integrationType = actionData.action_type;
    var webSearchPrompt = (_h = (_g = (_f = actionData.action_details) === null || _f === void 0 ? void 0 : _f['1']) === null || _g === void 0 ? void 0 : _g.prompt) !== null && _h !== void 0 ? _h : '';
    var webSearchContextKeywords = (_l = (_k = (_j = actionData.action_details) === null || _j === void 0 ? void 0 : _j['1']) === null || _k === void 0 ? void 0 : _k.enforce_keywords) !== null && _l !== void 0 ? _l : '';
    var ragPrompt = (_p = (_o = (_m = actionData.action_details) === null || _m === void 0 ? void 0 : _m['2']) === null || _o === void 0 ? void 0 : _o.prompt) !== null && _p !== void 0 ? _p : '';
    var appId = (_s = (_r = (_q = actionData.action_details) === null || _q === void 0 ? void 0 : _q['2']) === null || _r === void 0 ? void 0 : _r.app_id) !== null && _s !== void 0 ? _s : '';
    var locationId = (_v = (_u = (_t = actionData.action_details) === null || _t === void 0 ? void 0 : _t['2']) === null || _u === void 0 ? void 0 : _u.location_id) !== null && _v !== void 0 ? _v : '';
    var promptAsAnActionPrompt = (_y = (_x = (_w = actionData.action_details) === null || _w === void 0 ? void 0 : _w['3']) === null || _x === void 0 ? void 0 : _x.prompt) !== null && _y !== void 0 ? _y : '';
    var indexName = (_1 = (_0 = (_z = actionData.action_details) === null || _z === void 0 ? void 0 : _z['4']) === null || _0 === void 0 ? void 0 : _0.index_name) !== null && _1 !== void 0 ? _1 : '';
    var catalogId = (_4 = (_3 = (_2 = actionData.action_details) === null || _2 === void 0 ? void 0 : _2['4']) === null || _3 === void 0 ? void 0 : _3.meta_catalog_id) !== null && _4 !== void 0 ? _4 : '';
    var source = (_7 = (_6 = (_5 = actionData.action_details) === null || _5 === void 0 ? void 0 : _5['4']) === null || _6 === void 0 ? void 0 : _6.source) !== null && _7 !== void 0 ? _7 : '';
    var extendedCategoryPrompt = (_10 = (_9 = (_8 = actionData.action_details) === null || _8 === void 0 ? void 0 : _8['4']) === null || _9 === void 0 ? void 0 : _9.extended_category_prompt) !== null && _10 !== void 0 ? _10 : '';
    var responseFormat = (_12 = (_11 = actionData === null || actionData === void 0 ? void 0 : actionData.action_details) === null || _11 === void 0 ? void 0 : _11[4]) === null || _12 === void 0 ? void 0 : _12.meta_output_format;
    var displayPreferenceTitle = (_15 = (_14 = (_13 = actionData.function_details) === null || _13 === void 0 ? void 0 : _13.display_preference) === null || _14 === void 0 ? void 0 : _14.title) !== null && _15 !== void 0 ? _15 : '';
    var displayPreferenceSubtitle = (_18 = (_17 = (_16 = actionData.function_details) === null || _16 === void 0 ? void 0 : _16.display_preference) === null || _17 === void 0 ? void 0 : _17.sub_title) !== null && _18 !== void 0 ? _18 : '';
    var displayPreferenceImageLink = (_21 = (_20 = (_19 = actionData.function_details) === null || _19 === void 0 ? void 0 : _19.display_preference) === null || _20 === void 0 ? void 0 : _20.image_link) !== null && _21 !== void 0 ? _21 : '';
    var displayPreferenceProductLink = (_24 = (_23 = (_22 = actionData.function_details) === null || _22 === void 0 ? void 0 : _22.display_preference) === null || _23 === void 0 ? void 0 : _23.product_link) !== null && _24 !== void 0 ? _24 : '';
    var displayPreferenceButtonsConfigType = (_28 = (_27 = (_26 = (_25 = actionData.function_details) === null || _25 === void 0 ? void 0 : _25.display_preference) === null || _26 === void 0 ? void 0 : _26.buttons_config) === null || _27 === void 0 ? void 0 : _27.type) !== null && _28 !== void 0 ? _28 : '';
    var displayPreferenceButtons = (_32 = (_31 = (_30 = (_29 = actionData.function_details) === null || _29 === void 0 ? void 0 : _29.display_preference) === null || _30 === void 0 ? void 0 : _30.buttons_config) === null || _31 === void 0 ? void 0 : _31.buttons) !== null && _32 !== void 0 ? _32 : '';
    var numberOfDisplayedProducts = (_34 = (_33 = actionData.function_details) === null || _33 === void 0 ? void 0 : _33.hits_per_page) !== null && _34 !== void 0 ? _34 : '';
    var enableProductFollowUpMsgs = (_37 = (_36 = (_35 = actionData.action_details) === null || _35 === void 0 ? void 0 : _35['4']) === null || _36 === void 0 ? void 0 : _36.enable_prod_follow_up_msgs) !== null && _37 !== void 0 ? _37 : true;
    var productFollowUpParams = (_40 = (_39 = (_38 = actionData.action_details) === null || _38 === void 0 ? void 0 : _38['4']) === null || _39 === void 0 ? void 0 : _39.aisa_follow_msg_params) !== null && _40 !== void 0 ? _40 : [];
    var followUpEnabled = (_43 = (_42 = (_41 = actionData.function_details) === null || _41 === void 0 ? void 0 : _41.follow_up_data) === null || _42 === void 0 ? void 0 : _42.follow_up_enabled) !== null && _43 !== void 0 ? _43 : false;
    var followUpHsl = (_46 = (_45 = (_44 = actionData.function_details) === null || _44 === void 0 ? void 0 : _44.follow_up_data) === null || _45 === void 0 ? void 0 : _45.follow_up_hsl) !== null && _46 !== void 0 ? _46 : [];
    var functionNameRegex = /^(?=.*[a-zA-Z0-9])[\w]*$/;
    var actionNameRegex = /^(?=.*[a-zA-Z0-9])[ \w]*$/;
    var ragRegex = /^[a-zA-Z0-9_-]+$/;
    var isError = false;
    var isDisplayPreferenceError = false;
    var actionErrors = {};
    if (!(functionName === null || functionName === void 0 ? void 0 : functionName.trim())) {
        isError = true;
        actionErrors['functionNameError'] =
            "Please enter a function name. It can't be left blank.";
    }
    else if (!functionNameRegex.test(functionName.trim())) {
        isError = true;
        actionErrors['functionNameError'] =
            'Function names can only include letters, numbers, and underscores.';
    }
    else if (functionName.trim().length > 64) {
        isError = true;
        actionErrors['functionNameError'] =
            'Function names must be 64 characters or fewer.';
    }
    else if (((_47 = functionName.trim()) === null || _47 === void 0 ? void 0 : _47.toLowerCase()) === 'break') {
        isError = true;
        actionErrors['functionNameError'] =
            "'break' keyword can not be used as a function name.";
    }
    if (!(actionName === null || actionName === void 0 ? void 0 : actionName.trim())) {
        isError = true;
        actionErrors['actionNameError'] =
            "Please enter the action name. It can't be left blank.";
    }
    else if (!actionNameRegex.test(actionName.trim())) {
        isError = true;
        actionErrors['actionNameError'] =
            'Action name can only include letters, numbers, underscores and spaces.';
    }
    else if (((_48 = actionName.trim()) === null || _48 === void 0 ? void 0 : _48.toLowerCase()) === 'break') {
        isError = true;
        actionErrors['actionNameError'] =
            "'break' keyword can not be used in action name.";
    }
    if (!(actionDescription === null || actionDescription === void 0 ? void 0 : actionDescription.trim())) {
        isError = true;
        actionErrors['actionDescriptionError'] =
            "Please enter the description for the action. It can't be left blank.";
    }
    if (actionDescription.length > 1024) {
        isError = true;
        actionErrors['actionDescriptionError'] =
            'Action description must be of length 1024 characters or less.';
    }
    if (integrationType === 1 && !(webSearchPrompt === null || webSearchPrompt === void 0 ? void 0 : webSearchPrompt.trim())) {
        isError = true;
        actionErrors['webSearchPromptError'] =
            "Please enter the prompt. It can't be left blank.";
    }
    else if (integrationType === 1 && webSearchPrompt.trim().length > 100000) {
        isError = true;
        actionErrors['webSearchPromptError'] =
            'Prompt for web search must be of length 100000 characters or less.';
    }
    else if (integrationType === 1 && !webSearchPrompt.includes('[BREAK]')) {
        isError = true;
        actionErrors['webSearchPromptError'] =
            'Prompt for web search must have [BREAK] condition.';
    }
    else if (integrationType === 1 &&
        (webSearchContextKeywords === null || webSearchContextKeywords === void 0 ? void 0 : webSearchContextKeywords.split(' ').length) > 30) {
        isError = true;
        actionErrors['webSearchContextKeywordError'] =
            'WebSearch Context Keywords must be limited to a maximum of 30 words.';
    }
    if (integrationType === 2) {
        if (!(ragPrompt === null || ragPrompt === void 0 ? void 0 : ragPrompt.trim())) {
            isError = true;
            actionErrors['ragPromptError'] =
                "Please enter the prompt. It can't be left blank.";
        }
        else if (ragPrompt.trim().length > 5000) {
            isError = true;
            actionErrors['ragPromptError'] =
                'Prompt for RAG must be of length 5000 characters or less.';
        }
        if (!(locationId === null || locationId === void 0 ? void 0 : locationId.trim())) {
            isError = true;
            actionErrors['locationIdError'] =
                "Please enter the Location ID. It can't be left blank.";
        }
        else if (!ragRegex.test(locationId.trim())) {
            isError = true;
            actionErrors['locationIdError'] =
                'Location ID can only include letters, numbers, underscores and dashes.';
        }
        if (!(appId === null || appId === void 0 ? void 0 : appId.trim())) {
            isError = true;
            actionErrors['appIdError'] =
                "Please enter the App ID. It can't be left blank.";
        }
        else if (!ragRegex.test(appId.trim())) {
            isError = true;
            actionErrors['appIdError'] =
                'App ID can only include letters, numbers, underscores and dashes.';
        }
    }
    if (integrationType === 3) {
        if (!(promptAsAnActionPrompt === null || promptAsAnActionPrompt === void 0 ? void 0 : promptAsAnActionPrompt.trim())) {
            isError = true;
            actionErrors['promptActionError'] =
                "Please enter the prompt. It can't be left blank.";
        }
        else if (promptAsAnActionPrompt.trim().length > 140000) {
            isError = true;
            actionErrors['promptActionError'] =
                'Prompt must be of length 140000 characters or less.';
        }
        else if (!promptAsAnActionPrompt.includes('[BREAK]')) {
            isError = true;
            actionErrors['promptActionError'] = 'Prompt must have [BREAK] condition.';
        }
    }
    if (integrationType === 4) {
        if (!indexName && source === 'Manual') {
            isError = true;
            actionErrors['indexNameError'] =
                "Please enter the index name. It can't be left blank.";
        }
        if (!displayPreferenceTitle) {
            isError = true;
            isDisplayPreferenceError = true;
            actionErrors['displayPreferenceTitleError'] =
                "Please enter the title. It can't be left blank.";
        }
        if (!displayPreferenceSubtitle &&
            responseFormat !== 'meta_image_and_cta_format') {
            isError = true;
            isDisplayPreferenceError = true;
            actionErrors['displayPreferenceSubtitleError'] =
                "Please enter the subtitle. It can't be left blank.";
        }
        if (!displayPreferenceImageLink) {
            isError = true;
            isDisplayPreferenceError = true;
            actionErrors['displayPreferenceImageLinkError'] =
                "Please enter the image link. It can't be left blank.";
        }
        if (!displayPreferenceProductLink) {
            isError = true;
            isDisplayPreferenceError = true;
            actionErrors['displayPreferenceProductLinkError'] =
                "Please enter the product link. It can't be left blank.";
        }
        if (!numberOfDisplayedProducts) {
            isError = true;
            isDisplayPreferenceError = true;
            actionErrors['hitsPerPageError'] =
                'Number of products displayed is required';
        }
        else if (numberOfDisplayedProducts < 5) {
            isError = true;
            isDisplayPreferenceError = true;
            actionErrors['hitsPerPageError'] =
                'Number of products displayed must have at least 5 products';
        }
        if (displayPreferenceButtonsConfigType) {
            displayPreferenceButtons.forEach(function (button, index) {
                var _a;
                if (!(button === null || button === void 0 ? void 0 : button.display_text)) {
                    isError = true;
                    isDisplayPreferenceError = true;
                    actionErrors["displayPreferenceButton" + (index + 1) + "DisplayTextError"] =
                        'Display text is mandatory';
                }
                if (((_a = button === null || button === void 0 ? void 0 : button.display_text) === null || _a === void 0 ? void 0 : _a.length) > 20) {
                    isError = true;
                    isDisplayPreferenceError = true;
                    actionErrors["displayPreferenceButton" + (index + 1) + "DisplayTextError"] =
                        'Display text should be less than 20 characters';
                }
                if (displayPreferenceButtonsConfigType === 'reply' &&
                    !(button === null || button === void 0 ? void 0 : button.reply_text)) {
                    isError = true;
                    isDisplayPreferenceError = true;
                    actionErrors["displayPreferenceButton" + (index + 1) + "ReplyTextError"] =
                        'Reply text is mandatory';
                }
            });
        }
        if (isDisplayPreferenceError) {
            actionErrors['responseFormatError'] =
                'Please check all the fields for the selected response format.';
        }
        if (!catalogId && source === 'Meta Catalog') {
            isError = true;
            actionErrors['catalogIdError'] = 'Please enter valid Catalog Id.';
        }
        if (catalogId && errors.actionErrors['catalogIdError']) {
            isError = true;
            actionErrors['catalogIdError'] = errors.actionErrors['catalogIdError'];
        }
        if (enableProductFollowUpMsgs) {
            if (!productFollowUpParams.length) {
                isError = true;
                actionErrors['productFollowUpParamsError'] =
                    'Follow up Params are mandatory if Product Follow up Messages toggle is on.';
            }
        }
        if (extendedCategoryPrompt.length > 1000) {
            isError = true;
            actionErrors['extendedCategoryPromptError'] =
                'Extended Category Prompt must be 1000 words or fewer.';
        }
        if ([0, 1, 2].some(function (index) {
            console.log('errors', errors.actionErrors["displayPreferenceButton" + (index + 1) + "ReplyTextError"], errors.actionErrors["displayPreferenceButton" + (index + 1) + "DisplayTextError"]);
            return (errors.actionErrors["displayPreferenceButton" + (index + 1) + "ReplyTextError"] ||
                errors.actionErrors["displayPreferenceButton" + (index + 1) + "DisplayTextError"]);
        })) {
            isError = true;
        }
    }
    if (followUpEnabled && !(followUpHsl === null || followUpHsl === void 0 ? void 0 : followUpHsl.length)) {
        isError = true;
        actionErrors['followUpHslError'] = 'Please enter at least one element.';
    }
    var actionParametersError = functionParameterList.map(function (_a, index) {
        var _b;
        var mandatory = _a.mandatory, facet = _a.facet, param_name = _a.param_name, param_type = _a.param_type, param_description = _a.param_description, _c = _a.possible_values, possible_values = _c === void 0 ? [] : _c;
        var errorObj = {};
        if (!(param_name === null || param_name === void 0 ? void 0 : param_name.trim())) {
            isError = true;
            errorObj['nameError'] =
                "Pease enter a parameter name. It can't be left blank.";
        }
        if (!functionNameRegex.test(param_name === null || param_name === void 0 ? void 0 : param_name.trim())) {
            isError = true;
            errorObj['nameError'] =
                'Parameter name can only include letters, numbers, and underscores.';
        }
        if (!param_type) {
            isError = true;
            errorObj['typeError'] =
                "Please select the parameter type. It can't be left unselected.";
        }
        if (!(param_description === null || param_description === void 0 ? void 0 : param_description.trim())) {
            isError = true;
            errorObj['descriptionError'] =
                "Please enter a parameter description. It can't be left blank.";
        }
        if (((_b = param_description === null || param_description === void 0 ? void 0 : param_description.trim()) === null || _b === void 0 ? void 0 : _b.split(/\s+/).length) >
            (actionType === 4 ? 4000 : 300)) {
            isError = true;
            errorObj['descriptionError'] = "Parameter Description must be " + (actionType === 4 ? '4000' : '300') + " words or fewer.";
        }
        if ((param_type === null || param_type === void 0 ? void 0 : param_type.trim()) &&
            param_type === 'enum' &&
            !(possible_values === null || possible_values === void 0 ? void 0 : possible_values.length)) {
            isError = true;
            errorObj['possibleValuesError'] =
                'Please enter possible values. This field cannot be left blank.';
        }
        return errorObj;
    });
    return {
        isError: isError,
        actionErrors: actionErrors,
        actionParametersError: actionParametersError,
    };
};
exports.getDefaultPrompt = function (companyName, companyDescription) {
    return "You are a helpful assistant who answers questions about " + (companyName ? companyName : '[Brand Name]') + ".\n\n" + (companyDescription ? companyDescription : '[Brand Description]') + "\n\n## BREAK\nYou should break in the following instances:\n1. If you do not have enough information to answer this query. \n2. If the query is not related to " + (companyName ? companyName : '[Brand Name]') + " at all\n3. If the query is about " + (companyName ? companyName : '[Brand Name]') + "'s competitors \n\nIn this case, respond simply with \"[BREAK]\" and nothing else.";
};
exports.redirectToAgent = function (agentId, domainId) {
    History_1["default"].push("/ai-agents-project/" + domainId + "/agent/" + agentId);
};
function formatTimestamp(timestamp) {
    if (!timestamp)
        return '';
    var date = new Date(timestamp);
    var pad = function (n) { return n.toString().padStart(2, '0'); };
    var day = pad(date.getDate());
    var month = pad(date.getMonth() + 1); // Months are zero-based
    var year = date.getFullYear();
    var hours = date.getHours();
    var minutes = pad(date.getMinutes());
    var seconds = pad(date.getSeconds());
    var ampm = hours >= 12 ? 'PM' : 'AM';
    hours %= 12;
    hours = hours === 0 ? 12 : hours; // 0 should be 12 in 12-hour format
    var formattedHours = pad(hours);
    return day + "-" + month + "-" + year + " " + formattedHours + ":" + minutes + ":" + seconds + " " + ampm;
}
exports.formatTimestamp = formatTimestamp;
